import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Text } from "@performyard/py-components";

/** "Improved with AI" label shown above an input after an AI coach suggestion is applied. */
export const ImprovedWithAiBadge = () => (
	<Text
		size="caption"
		weight="semi-bold"
		color="primary-6"
		overrideElement="span"
		dangerouslySetClassName="inline-flex items-center gap-1"
	>
		<FontAwesomeIcon icon={faSparkles} style={{ fontSize: "10px" }} />
		Improved with AI
	</Text>
);

export default ImprovedWithAiBadge;
